import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Scadenza} from "../../Scadenzario/Models/Scadenza";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ScadenzeStoreService} from "../../Scadenzario/_services/scadenze-store.service";
import {RmaStoreService} from "../_services/rma-store.service";
import {RmaEditComponent} from "../rma-edit/rma-edit.component";
import {EditAttivitaRmaComponent} from "../edit-attivita-rma/edit-attivita-rma.component";
import {ApiRestService} from "../_services/api-rest.service";
import {EditEsitiRmaComponent} from "../edit-esiti-rma/edit-esiti-rma.component";
import {CampoAggiuntivo} from "../../shared/models/campo-aggiuntivo";
import { environment } from 'src/environments/environment';
import { Permission } from 'src/app/Login/_guards/Permission';
import {AuthenticationService} from "../../Login/_services/authentication.service";

@Component({
  selector: 'app-esiti-rma',
  templateUrl: './esiti-rma.component.html',
  styleUrls: ['./esiti-rma.component.css']
})
export class EsitiRmaComponent implements OnInit {
  @Input() ListaScadenze: Scadenza[] = [];
  @Output() ListaScadenzeChange= new EventEmitter<Scadenza[]>();
  @Input() checkSelezionate: { check?: string; id?: number; risposta?: boolean; fields?: CampoAggiuntivo[] } [] = [];
  @Input() Padre: any = null;
  @Output() AddButtonClick = new EventEmitter<Scadenza>();
  @Output() Updated = new EventEmitter<Scadenza>();
  @Input() editEnabled: boolean = null;
  @Output() editEnabledChange = new EventEmitter<boolean>();
  environment = environment;
  constructor(
    private modalService: NgbModal,
    private scadenzeStore: ScadenzeStoreService,
    private RmaStore: RmaStoreService,
    private apirestservice: ApiRestService,
    public permission: Permission,
  ) { }

  hasDynamicHeader(): boolean{
    return environment.RmaAddOn['CampiEsito']?.some(x=> x['viewInList']);
  }
  ngOnInit(): void {
  }

  whoismyfather(){
    console.log(this.Padre)
    if (this.Padre && !this.Padre.rma)
      this.ScadModBtn(this.Padre)
    else if (this.Padre && this.Padre.rma) {
      this.RmaStore.updateSelected(this.Padre);
      const editmodal = this.modalService.open(RmaEditComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<RmaEditComponent>editmodal.componentInstance).IsModal = true;
      (<RmaEditComponent>editmodal.componentInstance).added.subscribe(data=>{});
      (<RmaEditComponent>editmodal.componentInstance).updated.subscribe(data=> {});
    }
  }

  ScadAddButton() {
    this.AddButtonClick.emit();
  }
  ScadModBtn(event) {
    const editmodal = this.modalService.open(EditEsitiRmaComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditEsitiRmaComponent>editmodal.componentInstance).IsModal = true;
    (<EditEsitiRmaComponent>editmodal.componentInstance).Item = event;
    (<EditEsitiRmaComponent>editmodal.componentInstance).checkSelezionate = this.checkSelezionate?.filter(x=>x.risposta);
    (<EditEsitiRmaComponent>editmodal.componentInstance).added.subscribe(data=>{});
    (<EditEsitiRmaComponent>editmodal.componentInstance).updated.subscribe(data=> {this.Updated.emit()});
  }

  Delete(scadenza) {
    if(confirm('Sei sicuro di voler eliminare questo elemento?'))
      this.apirestservice.DeleteSegnalazione(scadenza).subscribe( data=> this.Updated.emit())
  }
}
